import { Editor } from "@monaco-editor/react";
import {
  ProjectFilesListStatus,
  useProjectFilesListStatus,
  useProjectFilesSelectedFileContent,
  useProjectFilesSelectedFilePath,
} from "../../../core_stores/useProjectFilesListStore";
import { useTheme } from "../../../providers/ThemeProvider";
import { ProjectFilesImagePreview } from "./ProjectFilesImagePreview";

const IMAGE_EXTENSIONS = [
  ".png",
  ".jpg",
  ".jpeg",
  ".gif",
  ".bmp",
  ".webp",
  ".svg",
  ".ico",
];

export function ProjectFilesSelectedFile() {
  const status = useProjectFilesListStatus();
  const selectedFilePath = useProjectFilesSelectedFilePath();
  const selectedFileContent = useProjectFilesSelectedFileContent();
  const { resolvedTheme } = useTheme();

  if (status === ProjectFilesListStatus.LOADING_FILE) {
    return <CircularProgressIndicator />;
  }

  if (!selectedFileContent) {
    return (
      <div
        className="flex items-center justify-center h-full 
      text-light-text dark:text-dark-text"
      >
        No file selected
      </div>
    );
  }

  // Check if the selected file is an image
  const isImageFile = IMAGE_EXTENSIONS.some((ext) =>
    selectedFilePath?.toLowerCase().endsWith(ext)
  );

  if (isImageFile) {
    return <ProjectFilesImagePreview />;
  }

  return (
    <div className="flex-1 h-full overflow-auto touch-pan-x">
      <div className="min-w-full h-full">
        <Editor
          height="100%"
          defaultLanguage="dart"
          value={selectedFileContent}
          loading={
            <div className="text-light-text dark:text-dark-text">
              Preparing code...
            </div>
          }
          options={{
            readOnly: true,
            domReadOnly: true,
            minimap: { enabled: false },
            fontSize: 13,
            lineNumbers: "on",
            scrollBeyondLastLine: false,
            automaticLayout: true,
            wordWrap: "off",
            scrollbar: {
              vertical: "visible",
              horizontal: "visible",
              useShadows: false,
              verticalScrollbarSize: 10,
              horizontalScrollbarSize: 10,
            },
          }}
          theme={resolvedTheme === "dark" ? "vs-dark" : "vs-light"}
        />
      </div>
    </div>
  );
}

function CircularProgressIndicator() {
  return (
    <div className="flex items-center justify-center h-full">
      <div
        className="w-8 h-8 border-4 
        border-white/75 dark:border-black/20
        border-t-primary-blue border-l-primary-blue border-r-primary-blue
        dark:border-t-primary-blue dark:border-l-primary-blue dark:border-r-primary-blue
        rounded-full animate-spin"
      ></div>
    </div>
  );
}
